module.exports = __webpack_public_path__ + "il.c137902085152302d55d.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/il.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/il.svg
// module chunks = styles